import { render, staticRenderFns } from "./BuildTeams.vue?vue&type=template&id=a8ffd100&scoped=true"
import script from "./BuildTeams.vue?vue&type=script&lang=js"
export * from "./BuildTeams.vue?vue&type=script&lang=js"
import style0 from "./BuildTeams.vue?vue&type=style&index=0&id=a8ffd100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ffd100",
  null
  
)

export default component.exports